var LayoutData_ImagePosition = /* @__PURE__ */ ((LayoutData_ImagePosition2) => {
  LayoutData_ImagePosition2["CENTER"] = "CENTER";
  LayoutData_ImagePosition2["CENTER_LEFT"] = "CENTER_LEFT";
  LayoutData_ImagePosition2["CENTER_RIGHT"] = "CENTER_RIGHT";
  LayoutData_ImagePosition2["TOP"] = "TOP";
  LayoutData_ImagePosition2["TOP_LEFT"] = "TOP_LEFT";
  LayoutData_ImagePosition2["TOP_RIGHT"] = "TOP_RIGHT";
  LayoutData_ImagePosition2["BOTTOM"] = "BOTTOM";
  LayoutData_ImagePosition2["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  LayoutData_ImagePosition2["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
  LayoutData_ImagePosition2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return LayoutData_ImagePosition2;
})(LayoutData_ImagePosition || {});
var LayoutData_ResponsivenessBehaviour = /* @__PURE__ */ ((LayoutData_ResponsivenessBehaviour2) => {
  LayoutData_ResponsivenessBehaviour2["STACK"] = "STACK";
  LayoutData_ResponsivenessBehaviour2["WRAP"] = "WRAP";
  LayoutData_ResponsivenessBehaviour2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return LayoutData_ResponsivenessBehaviour2;
})(LayoutData_ResponsivenessBehaviour || {});
var LayoutData_VerticalAlignment_Alignment = /* @__PURE__ */ ((LayoutData_VerticalAlignment_Alignment2) => {
  LayoutData_VerticalAlignment_Alignment2["TOP"] = "TOP";
  LayoutData_VerticalAlignment_Alignment2["MIDDLE"] = "MIDDLE";
  LayoutData_VerticalAlignment_Alignment2["BOTTOM"] = "BOTTOM";
  LayoutData_VerticalAlignment_Alignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return LayoutData_VerticalAlignment_Alignment2;
})(LayoutData_VerticalAlignment_Alignment || {});
var LayoutData_ImageScaling_Scaling = /* @__PURE__ */ ((LayoutData_ImageScaling_Scaling2) => {
  LayoutData_ImageScaling_Scaling2["AUTO"] = "AUTO";
  LayoutData_ImageScaling_Scaling2["CONTAIN"] = "CONTAIN";
  LayoutData_ImageScaling_Scaling2["COVER"] = "COVER";
  LayoutData_ImageScaling_Scaling2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return LayoutData_ImageScaling_Scaling2;
})(LayoutData_ImageScaling_Scaling || {});
export {
  LayoutData_ImagePosition,
  LayoutData_ImageScaling_Scaling,
  LayoutData_ResponsivenessBehaviour,
  LayoutData_VerticalAlignment_Alignment
};
//# sourceMappingURL=node_layout.enums.js.map
